import React, { Component } from 'react'
import { Table } from 'react-bootstrap'

class Referenten extends Component {
    constructor(props) {
        super(props)
        this.getReferences = this.getReferences.bind(this)
    }

    getReferences() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((ref, index) => {
            return <tr key={index}>
                <td>{ref.abbreviation}</td>
                <td>{ref.name}</td>
                <td>{ref.email}</td>
                <td>{ref.phone}</td>
                <td>{ref.function}</td>
            </tr>
        }) : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>Referenten</strong></h5>
                <Table responsive bordered className="referenten">
                    <thead>
                        <tr>
                            <th>Afkorting</th>
                            <th>Naam</th>
                            <th>E-mail</th>
                            <th>Telefoon</th>
                            <th>Functie</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getReferences()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default Referenten;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Referenten.js